<script>
/* ========= SWIPER-IMPORTS AUS DEM BEISPIEL ========= */
import {
  Autoplay,
  Thumbs,
  Pagination,
  Navigation,
  EffectCoverflow,
  Mousewheel,
  Scrollbar,
  EffectFade,
  EffectFlip,
  EffectCreative,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/vue";

/* ========= SWIPER-CSS-STYLES ========= */
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/mousewheel";
import "swiper/css/effect-fade";
import "swiper/css/effect-creative";
import "swiper/css/effect-flip";
import "swiper/css/effect-coverflow";

import HeaderMenu from "@/components/modules/HeaderMenu.vue";
import FooterSection from "@/components/modules/FooterSection.vue";

export default {
  name: "NewLanding",
  components: {
    HeaderMenu,
    FooterSection,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      /* Beispiel: Falls du andere Swiper-Setups brauchst, 
         kannst du wie im Original Beispiele anlegen. */
      hasYoutubeConsent: false,

      Autoplay,
      Thumbs,
      Pagination,
      Navigation,
      EffectCoverflow,
      Mousewheel,
      Scrollbar,
      EffectFade,
      EffectFlip,
      EffectCreative,

      // Diese Option zeigt dir, wie du die Dynamic Bullets & Pagination
      // an den Swiper übergeben kannst
      dynamicPaginationOptions: {
        clickable: true,
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    };
  },
  mounted() {
    this.checkConsent();
    // Hört auf das globale Event, um den Consent-Status zu aktualisieren
    window.addEventListener("cookieConsentChanged", this.handleConsentChanged);
  },
  beforeUnmount() {
    window.removeEventListener(
      "cookieConsentChanged",
      this.handleConsentChanged
    );
  },
  methods: {
    checkConsent() {
      const savedConsent = localStorage.getItem("cookieConsent");
      if (savedConsent) {
        try {
          const consentObj = JSON.parse(savedConsent);
          this.hasYoutubeConsent = consentObj.youtube === true;
        } catch (e) {
          this.hasYoutubeConsent = false;
        }
      }
    },
    allowYoutubeConsent() {
      // Direkte Zustimmung für YouTube über den Placeholder
      let consentObj = {};
      const savedConsent = localStorage.getItem("cookieConsent");
      if (savedConsent) {
        try {
          consentObj = JSON.parse(savedConsent);
        } catch (e) {
          consentObj = {};
        }
      }
      consentObj.youtube = true;
      localStorage.setItem("cookieConsent", JSON.stringify(consentObj));
      this.hasYoutubeConsent = true;
      // Dispatch des globalen Events, damit auch andere Komponenten informiert werden
      window.dispatchEvent(
        new CustomEvent("cookieConsentChanged", { detail: consentObj })
      );
    },
    handleConsentChanged(event) {
      const consent = event.detail;
      this.hasYoutubeConsent = consent.youtube === true;
    },
  },
};
</script>

<template>
  <div class="layout-wrapper landing">
    <!-- NAVBAR -->
    <HeaderMenu />

    <!-- =========================================
         BILDERSLIDER GANZ OBEN
         (Mit mt-md-5 und pt-md-5 wegen Abstand zum Header)
    ========================================== -->
    <div class="container-wrapper">
      <section class="p-0 container pt-md-5">
        <swiper
          style="max-height: 500px"
          class="pagination-dynamic-swiper rounded mt-md-5 pt-md-5"
          :loop="true"
          :autoplay="{ delay: 2500, disableOnInteraction: false }"
          :pagination="dynamicPaginationOptions"
          :modules="[Autoplay, Pagination]"
        >
          <swiper-slide>
            <img
              src="@/assets/images/sander/landing_01.jpg"
              alt="Landing 01"
              class="img-fluid"
            />
          </swiper-slide>
          <swiper-slide>
            <img
              src="@/assets/images/sander/landing_02.jpg"
              alt="Landing 02"
              class="img-fluid"
            />
          </swiper-slide>
          <swiper-slide>
            <img
              src="@/assets/images/sander/landing_03.jpg"
              alt="Landing 03"
              class="img-fluid"
            />
          </swiper-slide>
          <!-- Pagination-Element -->
          <div class="swiper-pagination dynamic-pagination"></div>
        </swiper>
      </section>

      <!-- =========================================
         HERO SECTION
    ========================================== -->

      <section
        class="d-flex align-items-center justify-content-center text-center text-white my-6"
      >
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="12">
              <div
                class="display-6 mb-0 text-primary"
                style="text-transform: uppercase; font-weight: 500"
              >
                {{ $t("t-landing-hero-heading-1") }}
              </div>
              <h3 class="fw-bold mb-4">
                {{ $t("t-landing-hero-heading-2") }}
              </h3>
              <h6 class="fs-4 fw-light">
                {{ $t("t-landing-hero-text") }}
              </h6>
            </BCol>
          </BRow>

          <BContainer class="text-center my-4">
            <BButton
              variant="primary"
              size="lg"
              :to="{ path: '/products' }"
              style="width: 250px"
            >
              {{ $t("t-landing-products-button") }}
            </BButton>
          </BContainer>
        </BContainer>
      </section>

      <section
        class="bg-light d-flex align-items-center justify-content-center text-center py-6"
      >
        <BContainer>
          <BRow class="my-5 my-md-0">
            <BCol md="4" class="text-center">
              <img
                src="@/assets/images/sander/LMH_Icons_performance_128_black.png"
                alt="Performance-Bild"
                width="80"
                class="img-fluid mb-5"
              />
              <h3 class="fs-3 fw-bold text-dark mb-1">
                {{ $t("t-landing-adds-01") }}
              </h3>
              <p>
                {{ $t("t-landing-adds-text-01") }}
              </p>
            </BCol>
            <BCol md="4" class="text-center">
              <img
                src="@/assets/images/sander/LMH_Icons_product_type_128_black.png"
                alt="Product-Typ-Bild"
                width="80"
                class="img-fluid mb-4"
              />
              <h3 class="fs-3 fw-bold text-dark mb-1">
                {{ $t("t-landing-adds-02") }}
              </h3>
              <p>
                {{ $t("t-landing-adds-text-02") }}
              </p>
            </BCol>
            <BCol md="4" class="text-center">
              <img
                src="@/assets/images/sander/LMH_Icons_chat_128_black.png"
                alt="Chat-Typ-Bild"
                width="80"
                class="img-fluid mb-4"
              />
              <h3 class="fs-3 fw-bold text-dark mb-1">
                {{ $t("t-landing-adds-03") }}
              </h3>
              <p>
                {{ $t("t-landing-adds-text-03") }}
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: GEPRÜFTE QUALITÄT
    ========================================== -->
      <section class="py-3" style="margin-top: 50px">
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="12">
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-quality-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-quality-text") }}
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: VORTEILE BEIM GEBRAUCHTSTAPLER-KAUF
    ========================================== -->
      <section class="pb-3">
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="12">
              <h2
                class="fs-2 fw-bold text-primary mb-3"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-benefits-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-benefits-intro") }}
              </p>

              <!-- 
            <h3 class="h4 mb-3 mt-5">
              {{ $t("t-landing-benefits-highlights-subheading") }}
            </h3>

            <BRow>
              <BCol md="4" class="mb-3">
                <div class="d-flex align-items-start">
                  <div class="me-2">
                    <i
                      class="mdi mdi-check-circle-outline text-primary fs-4"
                    ></i>
                  </div>
                  <div>
                    <p class="mb-0">
                      {{ $t("t-landing-benefits-highlight1") }}
                    </p>
                  </div>
                </div>
              </BCol>
              <BCol md="4" class="mb-3">
                <div class="d-flex align-items-start">
                  <div class="me-2">
                    <i
                      class="mdi mdi-check-circle-outline text-primary fs-4"
                    ></i>
                  </div>
                  <div>
                    <p class="mb-0">
                      {{ $t("t-landing-benefits-highlight2") }}
                    </p>
                  </div>
                </div>
              </BCol>
              <BCol md="4" class="mb-3">
                <div class="d-flex align-items-start">
                  <div class="me-2">
                    <i
                      class="mdi mdi-check-circle-outline text-primary fs-4"
                    ></i>
                  </div>
                  <div>
                    <p class="mb-0">
                      {{ $t("t-landing-benefits-highlight3") }}
                    </p>
                  </div>
                </div>
              </BCol>
            </BRow>
          -->
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: FINANZIERUNG UND RUNDUM-SERVICE
    ========================================== -->
      <section>
        <BContainer>
          <BRow class="justify-content-center pb-5">
            <BCol lg="12">
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-finance-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-finance-text") }}
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <section class="d-flex mt-1 justify-content-center">
        <BContainer>
          <BRow class="gx-5">
            <BCol md="6">
              <img
                src="@/assets/images/sander/Sander-Linde-Fahrzeugvorstellung.jpg"
                alt="Performance-Bild"
                class="img-fluid mb-4 image-fit"
              />
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-usp-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-usp-text") }}
              </p>
            </BCol>
            <BCol md="6">
              <img
                src="@/assets/images/sander/SliderPic_1.jpg"
                alt="Product-Typ-Bild"
                class="img-fluid mb-4 image-fit"
              />
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-qualityseal-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-qualityseal-text") }}
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <section class="d-flex mt-5 justify-content-center">
        <BContainer>
          <BRow class="gx-5">
            <BCol md="6">
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-performance-test-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-performance-test-text-1") }}
              </p>
              <p>
                {{ $t("t-landing-performance-test-text-2") }}
              </p>
              <p>
                {{ $t("t-landing-performance-test-text-3") }}
              </p>
              <!-- Falls keine Zustimmung vorliegt: Placeholder anzeigen -->
              <div v-if="!hasYoutubeConsent" class="youtube-placeholder">
                <div class="placeholder-content">
                  <p>{{ $t("t-landing-accept-youtube-text") }}</p>
                  <button class="accept-button" @click="allowYoutubeConsent">
                    {{ $t("t-landing-accept-youtube-button") }}
                  </button>
                </div>
              </div>
              <!-- Falls Zustimmung vorliegt: YouTube-Iframe einbinden -->
              <div v-else>
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube-nocookie.com/embed/gPKpQ1qivYs?si=LiGTvNiwqSH3nGL6"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </BCol>
            <BCol md="6">
              <img
                src="@/assets/images/sander/Gebrauchtstapler_Leistungspruefstand-Sander.jpg"
                alt="Product-Typ-Bild"
                class="img-fluid mb-4 image-fit-vertical"
              />
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: TECHNIK ZUM ANFASSEN (USP)
         SECTION: STAPLER MIT QUALITÄTSSIEGEL
    ========================================== -->
      <!-- 
    <section class="bg-light py-5">
      <BContainer>
        <BRow>
          <BCol md="6">
            <h2 class="fs-2 fw-bold text-primary mb-4">
              {{ $t("t-landing-usp-heading") }}
            </h2>
            <p>
              {{ $t("t-landing-usp-text") }}
            </p>
          </BCol>
          <BCol md="6">
            <h2 class="fs-2 fw-bold text-primary mb-4">
              {{ $t("t-landing-qualityseal-heading") }}
            </h2>
            <p>
              {{ $t("t-landing-qualityseal-text") }}
            </p>
          </BCol>
        </BRow>
      </BContainer>
    </section>
    -->

      <!-- =========================================
         ZWEITES BREITES BILD
         (Falls du hier noch ein großes Bild brauchst)
    ========================================== -->
      <!--
    <section class="bg-light pb-5">
      <BContainer>
        <BRow class="justify-content-center">
          <BCol lg="12">
            <img
              src="@/assets/images/sander/landing_02.jpg"
              alt="Breites Gabelstapler-Bild"
              class="img-fluid rounded shadow"
            />
          </BCol>
        </BRow>
      </BContainer>
    </section>
    -->

      <!-- =========================================
         SECTION: CALL TO ACTION (CTA)
    ========================================== -->
      <section
        class="bg-primary text-white text-center align-items-center justify-content-center d-flex my-6 py-6"
      >
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="12">
              <h2 class="fs-2 fw-bold mb-4 text-white">
                {{ $t("t-landing-call-heading") }}
              </h2>
              <p class="fs-5 mb-4" style="font-weight: 100">
                {{ $t("t-landing-call-text") }}
              </p>

              <p class="mb-1">
                <strong class="pe-1">{{
                  $t("t-landing-call-contact-phone-label")
                }}</strong>
                <a
                  href="tel:+4937152338486"
                  class="text-white text-decoration-underline"
                  style="font-weight: 200"
                >
                  {{ $t("t-landing-call-contact-phone-number") }}
                </a>
              </p>
              <p class="mb-1">
                <strong class="pe-1">{{
                  $t("t-landing-call-contact-email-label")
                }}</strong>

                <a
                  href="mailto:gebrauchtstapler@sander-ft.de"
                  class="text-white text-decoration-underline"
                  style="font-weight: 200"
                >
                  gebrauchtstapler@sander-ft.de
                </a>
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: NEWSLETTER
    ========================================== -->
      <section
        class="align-items-center justify-content-center d-flex p-4 p-md-0 newsletter my-6"
      >
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="6" class="text-center">
              <img
                src="@/assets/images/sander/Sander-Newsletter.jpg"
                alt="Performance-Bild"
                class="img-fluid mb-4 px-4"
              />
            </BCol>
            <BCol lg="6">
              <h2
                class="fs-2 text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-newsletter-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-newsletter-text") }}
              </p>
              <p>
                {{ $t("t-landing-newsletter-text-2") }}
              </p>
              <div class="mt-3">
                <button class="btn btn-primary btn-lg">
                  <a
                    href="https://subscribe.newsletter2go.com/?n2g=bhiskr47-nphiv59f-rxa&_ga=2.252266441.1525145637.1588670699-675360909.1583393004"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary btn-lg mx-auto"
                    style="text-transform: uppercase"
                  >
                    {{ $t("t-landing-newsletter-button") }}
                  </a>
                </button>
              </div>
            </BCol>
          </BRow>
        </BContainer>
      </section>

      <!-- =========================================
         SECTION: VERTRAUEN SIE AUF SANDER FÖRDERTECHNIK
    ========================================== -->
      <section class="pb-5">
        <BContainer>
          <BRow class="justify-content-center">
            <BCol lg="12">
              <h2
                class="fs-2 fw-bold text-primary mb-4"
                style="text-transform: uppercase"
              >
                {{ $t("t-landing-trust-heading") }}
              </h2>
              <p>
                {{ $t("t-landing-trust-text") }}
              </p>
              <p class="mt-1 fw-bold">
                {{ $t("t-landing-trust-test-2") }}
              </p>
            </BCol>
          </BRow>
        </BContainer>
      </section>
    </div>
    <!-- FOOTER -->
    <FooterSection />
  </div>
</template>

<style scoped>
.youtube-placeholder {
  width: 100%;
  height: 315px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border: 1px solid #ddd;
  position: relative;
}

.placeholder-content {
  text-align: center;
  padding: 1rem;
}

.accept-button {
  margin-top: 10px;
  padding: 8px 16px;
  background-color: var(--primary);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>

<style>
.container-wrapper {
  overflow-x: hidden;
}

.my-6 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.py-6 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

html,
body {
  overflow-wrap: break-word; /* sorgt dafür, dass lange Wörter umgebrochen werden */
  word-wrap: break-word;
}

.pagination-dynamic-swiper {
  height: 500px; /* oder dein gewünschter Wert */
}

.pagination-dynamic-swiper .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-dynamic-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.image-fit {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center;
}

.image-fit-vertical {
  width: 100%;
  height: 854px;
  object-fit: cover;
  object-position: center;
}

.btn {
  border-radius: 0;
}

@media (max-width: 768px) {
  .pagination-dynamic-swiper {
    /* Feste Höhe für mobile Ansicht */
    height: 300px;
    max-height: 500px; /* Begrenzung der maximalen Höhe */
  }

  .newsletter {
    text-align: center;
  }

  .image-fit-vertical {
    height: 350px;
  }
}
</style>
